module.exports = __webpack_public_path__ + "img/calendar-cover.72c9702f.png";